var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "a0fae302-bfbb-4ea6-a6f9-bfed7d783016",
        "data-name": "katman 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "500",
        height: "500",
        viewBox: "0 0 500 500",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#f07216", "fill-rule": "evenodd" },
        attrs: {
          d: "M264.60453,290.34862l-.749-4.59753a28.32124,28.32124,0,0,0,.749,4.59753M98.83825,407.08943l53.56284-10.21682,6.01933,36.92987,28.118-43.44161,31.78116-6.06219a59.65425,59.65425,0,0,0,36.35013-23.10844,78.02941,78.02941,0,0,1-14.92143-9.95,42.30921,42.30921,0,0,1-24.43779,14.594L95.82855,388.625c-23.46966,4.47651-46.0581-12.63333-50.19617-38.02311C27.77558,241.05109,42.421,330.90052,24.56474,221.34819c-4.13857-25.38933,11.67767-49.82472,35.14733-54.30178l119.48148-22.79075c19.83192-3.78295,39.03273,7.84787,47.00629,26.86163l4.25187-26.08389c-13.56852-15.22694-33.675-23.17038-54.26786-19.24274L56.70248,148.582C23.84478,154.84957,1.70216,189.05941,7.4958,224.6045L28.56344,353.85763C34.35719,389.40272,65.98057,413.35692,98.83825,407.08943Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#f07216", "fill-rule": "evenodd" },
        attrs: {
          d: "M151.55628,352.61c-43.90221,8.374-85.76938-23.25688-93.65009-70.68455-.016-.09723-.03487-.19391-.05093-.29114l-.00051-.00321c-1.01649-6.24482,2.84048-12.20226,8.61316-13.30311,5.7737-1.10129,11.28072,3.069,12.29977,9.31386l.001.00321c5.71277,35.03957,36.71158,58.51735,69.09993,52.33888,32.38887-6.17777,54.09508-39.70876,48.38528-74.74944l-.00042-.00266c-1.0166-6.24482,2.83986-12.20182,8.61356-13.30368,5.77268-1.10127,11.28022,3.07005,12.29978,9.31432h0l.001.00332c7.75628,47.58961-21.61991,92.97244-65.61158,101.3642",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#000000" },
        attrs: {
          d: "M245.77316,275.2907l-.01851.11283c-4.13858,25.38933,11.67818,49.82471,35.14835,54.30178l119.481,22.79075c23.47019,4.47695,46.05861-12.63278,50.19668-38.02269,17.85629-109.55131,3.21135-19.70122,21.06764-129.25366,4.13806-25.38922-11.67818-49.82516-35.14743-54.30167L317.019,108.12674c-23.47017-4.47707-46.05759,12.63333-50.19668,38.02255l-.018.11239Zm151.6011,95.67036-53.56181-10.21693L337.793,397.673,309.67456,354.2325l-31.78116-6.0623c-32.8582-6.2675-55.00133-40.4779-49.20718-76.023l4.59943-28.21944L245.154,171.113l4.58194-28.10714.0179-.11227c5.79364-35.54512,37.41713-59.49875,70.27481-53.23125L439.51056,112.453c32.85666,6.26749,55.00082,40.47745,49.20616,76.02254L467.64908,317.72926C461.85536,353.27435,430.232,377.22855,397.37426,370.96106Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#000000" },
        attrs: {
          d: "M344.65624,316.48105c43.90272,8.374,85.76937-23.25686,93.65009-70.684.01595-.09778.03487-.19391.05093-.29169l.00092-.00266c1.01659-6.24537-2.83987-12.20237-8.61357-13.30366s-11.28072,3.06948-12.30028,9.31428v.00278c-5.71276,35.04-36.71108,58.5178-69.10045,52.33946-32.38834-6.17845-54.095-39.70889-48.38525-74.74946l.0009-.00266c1.0166-6.24537-2.84088-12.20237-8.61356-13.30366-5.7737-1.10129-11.28073,3.06948-12.30029,9.31375h0v.00376c-7.75679,47.58917,21.61888,92.97255,65.61056,101.36374",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }